module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-toolbar",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "download-btn",
    on: {
      "click": _vm.downloadApp
    }
  }, [_c('img', {
    staticClass: "icon-logo",
    attrs: {
      "src": require("../assets/toolbar/icon-download.png")
    }
  }), _vm._v("\n            Unduh\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "add-to-home-btn",
    on: {
      "click": function($event) {
        _vm.showAddToHomeGuide = true
      }
    }
  }, [_vm._v("Layar Utama")])]), _vm._v(" "), (_vm.showAddToHomeGuide) ? [_c('div', {
    staticClass: "guide-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleClose($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "step",
    attrs: {
      "data-index": "3"
    }
  }, [_vm._v("Tambahkan setelah penamaan")]), _vm._v(" "), _c('img', {
    staticClass: "img-lite",
    attrs: {
      "src": require("../assets/toolbar/guide_3.png"),
      "alt": "All Sepakbola - Lite"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-add"
  }, [_vm._v("Dipahami")])]), _vm._v(" "), _c('div', {
    staticClass: "mask",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleClose($event)
      }
    }
  })] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step",
    attrs: {
      "data-index": "1"
    }
  }, [_vm._v("\n                Klik\n                "), _c('img', {
    staticClass: "icon-step",
    attrs: {
      "src": require("../assets/toolbar/guide_1.png")
    }
  }), _vm._v("\n                Tombol\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step",
    attrs: {
      "data-index": "2"
    }
  }, [_vm._v("\n                Klik\n                "), _c('img', {
    staticClass: "icon-step",
    attrs: {
      "src": require("../assets/toolbar/guide_2.png")
    }
  }), _vm._v("\n                Tambah ke Layar Utama\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e27a4f2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppToolbar.vue
// module id = 525
// module chunks = 2 3 5 6